module.exports = __webpack_public_path__ + "media/images/soar/Plameet2-05b1719731d47379bbdab91668b9c27a.png";